export enum InvoiceType {
  Invoice = "invoice",
  Deposit = "deposit",
  CreditNote = "creditNote",
}
